import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-batch-autocomplete-lib',
  template: `
    <p>
      batch-autocomplete-lib works!
    </p>
  `,
  styles: [
  ]
})
export class BatchAutocompleteLibComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
